module.exports = __webpack_public_path__ + "static/113_001-4d600539f806251da5d1ccc65787c58e.jpg";